import React from "react";
import { motion } from "framer-motion";
import { FaCertificate } from "react-icons/fa";
import "../App.css";

const certifications = [
  {
    title: "Google IT Support Professional",
    issuer: "Google (Coursera)",
    year: "2025",
    description:
      "A comprehensive 6-course professional program covering Technical Support, Networking, Operating Systems, System Administration, IT Security, and AI-driven troubleshooting strategies."
  },
  {
    title: "AWS Academy Cloud Foundations",
    issuer: "AWS Academy",
    year: "2023",
    description:
      "Core cloud concepts, AWS global infrastructure, compute, storage, networking, and security fundamentals."
  },
  {
    title: "Google Cloud Digital Leader",
    issuer: "Google Cloud",
    year: "2024",
    description:
      "Foundational cloud concepts, GCP products, business use cases, and cloud adoption strategies."
  },
  {
    title: "Create Serverless Applications",
    issuer: "Microsoft (Coursera)",
    year: "2024",
    description:
      "Serverless architecture, cloud functions, event-driven design, and managed services."
  },
  {
    title: "Deployment of Private Cloud",
    issuer: "IBM (Chandigarh University)",
    year: "2024",
    description:
      "Private cloud concepts, virtualization, deployment models, and infrastructure fundamentals."
  },
  {
    title: "Java Full Stack Training",
    issuer: "Arcane Programming Infotech",
    year: "2021",
    description:
      "Intensive training in Core Java, Servlets, JSP, MVC architecture, and JDBC."
  }
];

function Certifications() {
  return (
    <div>
      <h2 className="section-title text-center mb-5">Certifications</h2>
      <div className="row g-4">
        {certifications.map((cert, index) => (
          <div key={index} className="col-md-4">
            <div className="card-custom h-100">
              <h5 className="text-main fw-bold mb-2">{cert.title}</h5>
              <p className="small text-accent mb-2">{cert.issuer} • {cert.year}</p>
              <p className="text-dim mb-0 small">{cert.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Certifications;
